import React from "react";

import NavigationDropdown from "./NavigationDropdown";
import { NavigationLink } from "./NavigationLink";
import { NavigationLinkProps } from "./types";

/** Children decide the shape: a plain link without them, an expandable group with them. */
const NavigationItem: React.FC<NavigationLinkProps> = props =>
  props.children === undefined ? <NavigationLink {...props} /> : <NavigationDropdown {...props} />;

export { NavigationLink } from "./NavigationLink";
export type { NavigationLinkProps } from "./types";

export default NavigationItem;
